import {AppConsts} from "../AppConsts";

export default function l(key, args) {
  if (!AppConsts.languageDetails) {
    return key;
  }
  var localizedText = AppConsts.languageDetails[key];
  if (!localizedText) {
    localizedText = "[" + key + "]";
    console.warn(key + ":" + "not found");
  }

  if (args != null) {
    if (typeof args != "object") {
      return localizedText.format([args]);
    } else {
      return localizedText.format(args);
    }
  } else {
    return localizedText;
  }
}

String.prototype.format = function (args) {
  var result = this;
  if (args.length > 0) {
    for (var i = 0; i < args.length; i++) {
      if (args[i] != undefined) {
        var reg = "{" + i + "}";
        result = result.replace(reg, args[i]);
      }
    }
  }
  return result;
};



// WEBPACK FOOTER //
// ./src/shared/libs/ClientFramework/packages/abpVue/utils/abp.localization.js